import useOrgsOptions from 'app/hooks/useOrgsOptions';
import usePaginationParams from 'app/hooks/usePaginationParams';
import { FilterParams } from 'app/types/Filters';
import { FilterProps } from 'components/Dashboard/types';

import { Button, DatePicker, Form, Select, Space } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

const { RangePicker } = DatePicker;

const StatisticsFilter: React.FC<FilterProps> = ({ onApply }) => {
  const [ form ] = Form.useForm<FilterParams>();
  const { orgParam, minDateParam, maxDateParam, setFilters, clearFilters } = usePaginationParams();
  const { orgsOptions } = useOrgsOptions();

  const onReset = () => {
    form.setFieldValue('org', []);
    form.setFieldValue('date', [ null, null ]);
    clearFilters();
  };

  const onFinish = (values: FilterParams) => {
    setFilters(values);
    onApply();
  };

  return (
    <Form
      form={form}
      name="statisticsFilter"
      layout="vertical"
      requiredMark={false}
      onFinish={onFinish}
      style={{ width: 290 }}
      initialValues={{
        org: orgParam !== '' ? orgParam.split(',') : [],
        date: [
          minDateParam ? dayjs(minDateParam) : null,
          maxDateParam ? dayjs(maxDateParam) : null,
        ],
      }}
    >
      <Form.Item name="org">
        <Select
          placeholder="Select organizations"
          mode="multiple"
          options={orgsOptions}
        />
      </Form.Item>

      <Form.Item name="date">
        <RangePicker allowEmpty={[ true, true ]} format="MM/DD/YYYY" />
      </Form.Item>

      <Form.Item style={{ textAlign: 'right', marginBottom: 0 }}>
        <Space>
          <Button onClick={onReset}>
            Reset
          </Button>
          <Button type="primary" htmlType="submit">
            Apply
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default StatisticsFilter;
